import React from 'react';
import { Button, Illustration, Typography } from '@saviynt/design-system';
import {
  MemoryRouter as StyleguideMockRouter,
  useHistory,
} from 'react-router-dom';

import { useInvertedLocalize } from '../../../../utils';

import invertedMessages from './messages';

import './ExternalLandingPage.css';

function ExternalLandingPage() {
  const history = useHistory();
  const l = useInvertedLocalize(invertedMessages);

  return (
    <StyleguideMockRouter>
      <div className='Ext-ExternalLandingPage'>
        <div className='Ext-ExternalLandingPage-sectionOne'>
          <Typography
            kind='display4'
            className='Ext-ExternalLandingPage-sectionOne-title'>
            {l('Classify your External Identities')}
          </Typography>
          <Typography
            kind='body1'
            className='Ext-ExternalLandingPage-sectionOne-body'>
            {l(
              'Certain identity types cause security vulnerabilities to your organization. By understanding which identities pose greater risks, we can provide tailored insights and actionable recommendations to help you mitigate those risks effectively.'
            )}
          </Typography>
          <div className='Ext-ExternalLandingPage-sectionOne-img'>
            <div>
              {/* // TODO: Replace this, used to be HighRisk */}
              <Illustration kind='Warning' />
            </div>
          </div>
          <div className='Ext-ExternalLandingPage-sectionOne-actions'>
            <div>
              <Button
                className='Ext-ExternalLandingPage-sectionOne-actions-primaryButton'
                onClick={() => {
                  history.push({ pathname: '/manageClassification' });
                }}>
                {l('Start User Classification')}
              </Button>
            </div>
            {/* Temporarily commenting out the code until the actual links are available.
            <div>
              <Link
                to='/request/requestHistory'
                target='_blank'
                className='EXT-ExternalLandingPage-sectionOne-link'>
                {l('Learn more about high-risk identities')}
              </Link>
            </div> */}
          </div>
        </div>
        <div className='Ext-ExternalLandingPage-sectionTwo'>
          <div className='Ext-ExternalLandingPage-sectionTwo-title'>
            {l('Why is this important?')}
          </div>
          <Typography
            kind='body1'
            className='Ext-ExternalLandingPage-sectionTwo-description'>
            {l(
              'External users—such as contractors, vendors, partners, or any individuals not on your payroll (W2 employees)—often fall into higher-risk categories, making security insights critical. Many organizations lack visibility into the sheer number of these users and the associated security vulnerabilities they pose. Without clear visibility and control, these user groups can become blind spots that expose your organization to threats.'
            )}
          </Typography>
          <div className='Ext-ExternalLandingPage-sectionTwo-risk'>
            {/* // TODO: Replace this, used to be Risk */}
            <Illustration kind='Warning' />
            {/* <Illustration kind='Risk' /> */}
          </div>
          {/* Temporarily commenting out the code until the actual links are available.
          <div className='Ext-ExternalLandingPage-sectionTwo-link'>
            <Link to='/request/requestHistory' target='_blank'>
              {l('View full list of insights')}
            </Link>
          </div> */}
        </div>
        <div className='Ext-ExternalLandingPage-sectionThree'>
          <div className='Ext-ExternalLandingPage-sectionThree-title'>
            {l('What do I get')}
          </div>
          <Typography
            kind='body1'
            className='Ext-ExternalLandingPage-sectionThree-description'>
            {l(
              'By defining and classifying external users through our software, you gain a powerful control plane enriched with real-time security insights. These insights help you proactively identify risks, respond to threats, and ensure external user activity aligns with your security posture.'
            )}
          </Typography>
          <div className='Ext-ExternalLandingPage-sectionThree-risk'>
            <img
              src='/ECMv6/assets/images/illustrations/demo.svg'
              alt={l('Demo illustration')}
              className='Ext-ExternalLandingPage-demoIllustration'
            />
          </div>
          <div className='Ext-ExternalLandingPage-sectionThree-actions'>
            <div>
              <Button
                className='Ext-ExternalLandingPage-sectionThree-actions-primaryButton'
                onClick={() => {
                  history.push({ pathname: '/manageClassification' });
                }}>
                {l('Setup User Classification')}
              </Button>
            </div>
            {/* Temporarily commenting out the code until the actual links are available.
            <div>
              <Link
                to='/request/requestHistory'
                target='_blank'
                className='EXT-ExternalLandingPage-sectionThree-link'>
                {l('Learn more about high-risk identities')}
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </StyleguideMockRouter>
  );
}

export default ExternalLandingPage;
